module.exports = __webpack_public_path__ + "static/img/avatar.c1d6b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/avatar.png
// module id = PVjs
// module chunks = 115